import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, useStore } from 'react-redux';

import localApi from './api/localApi';
import mainApi from './api/mainApi';
import authSlice from './slice/authSlice';
import comparatorSlice from './slice/comparatorSlice';
import layoutSlice from './slice/layoutSlice';

export const makeStore = () => {
  return configureStore({
    reducer: {
      [localApi.reducerPath]: localApi.reducer,
      [mainApi.reducerPath]: mainApi.reducer,
      [authSlice.name]: authSlice.reducer,
      [layoutSlice.name]: layoutSlice.reducer,
      [comparatorSlice.name]: comparatorSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(localApi.middleware, mainApi.middleware),
  });
};

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
